import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Optional,
  Output,
  Self,
} from '@angular/core';

import { ControlValueAccessor, NgControl } from '@angular/forms';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { LexInputComponent } from '../lex-input/lex-input.component';

@EnableClassTelemetry()
@Component({
  selector: 'app-lex-numeric-input',
  templateUrl: './lex-numeric-input.component.html',
  styleUrls: ['./lex-numeric-input.component.scss'],
  standalone: false,
})
export class LexNumericInputComponent
  extends LexInputComponent
  implements OnInit, OnChanges, ControlValueAccessor
{
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() suffix: string;
  @Input() minValue: number;
  @Input() maxValue: number;
  @Input() decimals = 0;
  @Input() allowNegative: boolean;
  @Input() allowFractional: boolean;
  @Input() keepLastValid = true;
  @Input() autofocus: boolean;

  @Output() blur = new EventEmitter<any>();
  @Output() enterPressed = new EventEmitter<any>();

  constructor(@Self() @Optional() public ngControl: NgControl) {
    super(ngControl);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnChanges(changes) {
    super.ngOnChanges(changes);
  }
}
